<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span> <em name="Exhibition"></em> <span>/</span>詢問紀錄
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="contentBox">
        <h1>詢問紀錄</h1>
        <p class="my-3">&nbsp;</p>

        <div>
          <div id="SliderTop">
            <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
          </div>
          <div class="hasInquiry" v-if="show">
            <div class="alert text-dark alert-light mb-5" role="alert">
              <div v-if="replyStatus == 'all'">
                您的訊息共有 <span class="red">{{ totalNo }}</span> 筆， 目前顯示第
                <span class="red">{{ currentPage }}</span> 頁
              </div>
              <div v-else-if="replyStatus == 0">
                您的未回覆訊息共有 <span class="red">{{ totalNo }}</span> 筆， 目前顯示第
                <span class="red">{{ currentPage }}</span> 頁
              </div>
              <div v-else>
                您的已回覆訊息共有 <span class="red">{{ totalNo }}</span> 筆， 目前顯示第
                <span class="red">{{ currentPage }}</span> 頁
              </div>
            </div>
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist" style="font-size: 16px">
                <div
                  class="nav-item nav-link pointer"
                  :class="{ active: replyStatus == 'all' }"
                  id="nav-home-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                  @click="SwitchReStatus(null)"
                >
                  全部
                </div>
                <div
                  class="nav-item nav-link pointer"
                  :class="{ active: replyStatus == 0 }"
                  id="nav-profile-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false"
                  @click="SwitchReStatus(0)"
                >
                  未回覆
                </div>
                <div
                  class="nav-item nav-link pointer"
                  :class="{ active: replyStatus == 1 }"
                  id="nav-contact-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                  @click="SwitchReStatus(1)"
                >
                  已回覆
                </div>
              </div>
            </nav>
            <div class="PcDevice">
              <table class="table">
                <thead class="bg-light text-center">
                  <tr style="font-size: 17px">
                    <th scope="col">No.</th>
                    <th scope="col">詢問內容</th>
                    <th scope="col">姓名</th>
                    <th scope="col">詢問日期</th>
                    <th scope="col">回覆日期</th>
                    <th class="text-nowrap" scope="col">官網狀態</th>
                    <th scope="col">管理</th>
                  </tr>
                </thead>

                <tbody class="text-center">
                  <tr v-for="(item, key) in inquiryList" :key="item.No" style="font-size: 16px">
                    <th scope="row" class="text-nowrap align-middle">
                      {{ item.No }}
                    </th>
                    <td width="350px" class="text-left align-middle">
                      <p class="textOverflow">
                        {{ item.InquiryMessage }}
                      </p>
                      <div
                        v-if="item.NewsID !== '0'"
                        @click.prevent="showNewsModal(item.NewsID)"
                        style="font-size: 12px"
                      >
                        <i class="fas fa-eye mr-1"></i>
                        <span class="Preview-style">{{ item.InquiryItem }}</span>
                      </div>
                      <div
                        v-else-if="item.ProID !== '0'"
                        @click.prevent="showProModal(item.ProID)"
                        style="font-size: 12px"
                      >
                        <i class="fas fa-eye mr-1"></i>
                        <span class="Preview-style">{{ item.InquiryItem }}</span>
                      </div>
                    </td>
                    <td width="170px" class="align-middle">
                      <p class="textOverflow">
                        {{ item.InquiryName }}
                      </p>
                    </td>
                    <td class="text-nowrap align-middle">{{ item.CreateTime }}</td>
                    <td class="text-nowrap text-danger add-on align-middle" v-if="!item.ReplyTime">未回覆</td>
                    <td class="text-nowrap align-middle" v-else>{{ item.ReplyTime }}</td>

                    <td class="align-middle">
                      <div v-if="item.ProID !== '0'">
                        <span class="text-danger text-nowrap" v-if="item.Archived === 1">隱藏</span>
                        <span v-else class="text-success text-nowrap">顯示</span>
                      </div>
                      <div v-else-if="item.ProID == '0'">
                        <span class="text-nowrap"> - </span>
                      </div>
                    </td>
                    <td class="align-middle">
                      <div class="d-flex justify-content-center">
                        <div class="btn btn-primary text-nowrap" @click.prevent="editorBtn(item.InquiryID)">回覆</div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
                <nav>
                  <ul class="pagination">
                    <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                      <a class="page-link" href="#" title="切換前十頁" aria-label="Previous" @click="returntenPage()">
                        <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage == 1 }">
                      <a class="page-link" href="#" title="上一頁" aria-label="Previous" @click="lastPage()">
                        <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                      </a>
                    </li>
                    <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                      <a class="page-link" href="#" @click="getPage(page)">{{ page }}</a>
                    </li>

                    <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                      <a class="page-link" href="#" title="下一頁" aria-label="Next" @click="nextPage()">
                        <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                      </a>
                    </li>
                    <li
                      v-if="totaltenPageNum > 1"
                      class="page-item"
                      :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                    >
                      <a class="page-link" href="#" title="切換下十頁" aria-label="Next" @click="nexttenPage()">
                        <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                      </a>
                    </li>
                  </ul>
                  <p class="text-center mt-2">第 {{ currentPage }} / {{ totalPage }} 頁</p>
                </nav>
              </div>
            </div>

            <!-- 行動裝置 -->

            <div class="MbDevice">
              <div class="col-lg-10 text-dark">
                <div class="row">
                  <div class="col-sm-6 mb-2" v-for="(item, index) in inquiryList" :key="index">
                    <div class="card mt-3">
                      <div class="card-body">
                        <ul class="list-group list-group-flush">
                          <li class="list-group-item mt-1">
                            <div><span class="font-weight-bold">詢問內容:</span> {{ item.InquiryMessage }}</div>
                          </li>

                          <li class="list-group-item" v-if="item.NewsID !== '0' || item.ProID !== '0'">
                            <div v-if="item.NewsID !== '0'">
                              <span class="font-weight-bold">詢問來源:</span>
                              <span
                                @click.prevent="showNewsModal(item.NewsID)"
                                class="text-muted pointer"
                                style="font-size: 12px"
                              >
                                {{ item.InquiryItem }} <i class="fas fa-eye ml-1"></i>
                              </span>
                            </div>

                            <div v-if="item.ProID !== '0'">
                              <span class="font-weight-bold">詢問來源: </span
                              ><span
                                @click.prevent="showProModal(item.ProID)"
                                class="text-muted pointer"
                                style="font-size: 12px"
                              >
                                {{ item.InquiryItem }} <i class="fas fa-eye ml-1"></i>
                              </span>
                            </div>
                          </li>
                          <li class="list-group-item" v-if="item.ReplyMessage">
                            <div><span class="font-weight-bold">回覆內容:</span> {{ item.ReplyMessage }}</div>
                          </li>
                          <li class="list-group-item">
                            <span class="font-weight-bold">姓名:</span> {{ item.InquiryName }}
                          </li>
                          <li class="list-group-item">
                            <span class="font-weight-bold">詢問日期:</span> {{ item.CreateTime }}
                          </li>
                          <li class="list-group-item" v-if="item.ReplyTime">
                            <span class="font-weight-bold">回覆日期:</span> {{ item.ReplyTime }}
                          </li>
                          <li class="list-group-item" v-else>
                            <span class="font-weight-bold">回覆日期:</span> <span class="text-danger">未回覆</span>
                          </li>

                          <div class="d-flex justify-content-between align-items-center mx-3 mt-3">
                            <div>
                              <span class="font-weight-bold">官網狀態 :</span>
                              <span v-if="item.ProID !== '0'">
                                <span class="text-danger text-nowrap" v-if="item.Archived === 1">隱藏</span>
                                <span v-else class="text-success text-nowrap">顯示</span>
                              </span>
                              <span v-else-if="item.ProID == '0'">
                                <span class="text-nowrap"> - </span>
                              </span>
                            </div>
                            <div class="text-right">
                              <a
                                href="#"
                                class="btn btn-sm btn-primary text-right"
                                @click.prevent="editorBtn(item.InquiryID)"
                                >回覆
                              </a>
                            </div>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pt-3 d-flex justify-content-center">
                <nav>
                  <ul class="pagination pagination-sm">
                    <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                      <a class="page-link" href="#" aria-label="Previous" @click="returntenPage()">
                        <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage == 1 }">
                      <a class="page-link" href="#" aria-label="Previous" @click="lastPage()">
                        <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                      </a>
                    </li>
                    <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                      <a class="page-link" href="#" @click="getPage(page)">{{ page }}</a>
                    </li>

                    <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                      <a class="page-link" href="#" aria-label="Next" @click="nextPage()">
                        <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                      </a>
                    </li>
                    <li
                      v-if="totaltenPageNum > 1"
                      class="page-item"
                      :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                    >
                      <a class="page-link" href="#" aria-label="Next" @click="nexttenPage()">
                        <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                      </a>
                    </li>
                  </ul>
                  <p class="text-center mt-1" style="font-size: 10px">
                    第 {{ currentPage }} / {{ totalPage }}
                    頁
                  </p>
                </nav>
              </div>
            </div>

            <!-- Modal 新聞稿彈跳模組-->
            <div
              class="modal fade"
              id="openNewsModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="ModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <div class="PcDevice">
                      <div class="modal-title h3" id="ModalLabel">
                        <i class="fas fa-eye mr-1"></i>
                        詢問記錄來源（新聞稿示意圖）
                      </div>
                    </div>
                    <div class="MbDevice">
                      <div class="modal-title h5" id="ModalLabel">
                        <i class="fas fa-eye mr-1"></i>
                        詢問記錄來源（新聞稿示意圖）
                      </div>
                    </div>
                    <button type="button" class="close" aria-label="Close" @click.prevent="CloseNewsModal">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <nav>
                    <div class="nav mt-5 mx-3 nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-home-tab"
                        data-toggle="tab"
                        href="#nav-cn-news"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                        >中文版</a
                      >
                      <a
                        class="nav-item nav-link"
                        id="nav-profile-tab"
                        data-toggle="tab"
                        href="#nav-en-news"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="false"
                        >English</a
                      >
                    </div>
                  </nav>

                  <div class="tab-content mx-2" id="pills-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="nav-cn-news"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <div class="modal-body">
                        <div class="title-text-style my-4">{{ ModalData.NewsTopic }}</div>
                        <p>廠商名稱 : {{ CompanyName }}</p>
                        <p>發佈日期 : {{ newsUpdateTime }}</p>
                        <p>攤位號碼 : {{ BoothNo }}</p>
                        <div class="my-5 overflow-auto" v-html="ModalData.NewsContent">
                          {{ ModalData.NewsContent }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade show"
                      id="nav-en-news"
                      role="tabpanel"
                      aria-labelledby="pills-profile-tab"
                    >
                      <div class="modal-body">
                        <div class="my-5">
                          <div class="title-text-style my-4">{{ ModalData.eNewsTopic }}</div>
                          <p>Exhibitor : {{ eComName }}</p>
                          <p>Date : {{ newsUpdateTime }}</p>
                          <p>Booth No : {{ BoothNo }}</p>
                        </div>
                        <div class="mt-3 overflow-auto" v-html="ModalData.eNewsContent">
                          {{ ModalData.eNewsContent }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <div class="PcDevice">
                      <button type="button" class="btn btn-lg btn-secondary" @click.prevent="CloseNewsModal">
                        關閉
                      </button>
                    </div>
                    <div class="MbDevice">
                      <button type="button" class="btn btn-secondary" @click.prevent="CloseNewsModal">關閉</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal 產品彈跳視窗 -->

            <div
              class="modal fade"
              id="openProModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="ModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <div class="PcDevice">
                      <div class="modal-title h3" id="ModalLabel">
                        <i class="fas fa-eye mr-1"></i>
                        詢問記錄來源（參展產品示意圖）
                      </div>
                    </div>

                    <div class="MbDevice">
                      <div class="modal-title h5" id="ModalLabel">
                        <i class="fas fa-eye mr-1"></i>
                        詢問記錄來源（產品示意圖）
                      </div>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" @click.prevent="CloseProModal">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <nav>
                      <div class="nav mt-5 mx-3 nav-tabs" id="nav-tab" role="tablist">
                        <a
                          class="nav-item nav-link active"
                          id="nav-home-tab"
                          data-toggle="tab"
                          href="#nav-cn-pro"
                          role="tab"
                          aria-controls="nav-home"
                          aria-selected="true"
                          >中文版</a
                        >
                        <a
                          class="nav-item nav-link"
                          id="nav-profile-tab"
                          data-toggle="tab"
                          href="#nav-en-pro"
                          role="tab"
                          aria-controls="nav-profile"
                          aria-selected="false"
                          >English</a
                        >
                      </div>
                    </nav>

                    <div class="tab-content mx-2" id="pills-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="nav-cn-pro"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div class="row mt-5 justify-content-around">
                          <div class="col-4">
                            <img v-if="!ProductData.ProImg" src="@/assets/images/default.jpg" class="img-fluid" />
                            <img
                              v-else
                              :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${ProductData.ProImg}`"
                              class="img-fluid"
                            />
                          </div>
                          <div class="col-7">
                            <div class="title-text-style mb-4">
                              <div>{{ ProductData.ProName }}</div>
                            </div>
                            <p>產品型號 : {{ ProductData.ProModel }}</p>
                            <p>產品分類 : {{ SelectCat.CatName }}</p>
                            <p>廠商名稱 : {{ CompanyName }}</p>
                            <p>攤位號碼 : {{ BoothNo }}</p>
                            <hr />
                            <div class="my-3">
                              <p class="category-text-style my-3">產品特色</p>
                              <p class="mb-5">{{ ProductData.ProDesc }}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="tab-pane fade" id="nav-en-pro" role="tabpanel" aria-labelledby="pills-home-tab">
                        <div class="row mt-5 justify-content-around">
                          <div class="col-4">
                            <img src="@/assets/images/default.jpg" class="img-fluid" v-if="!ProductData.ProImg" />
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${ProductData.ProImg}`"
                              class="img-fluid"
                              v-else
                            />
                          </div>
                          <div class="col-7">
                            <div class="title-text-style mb-4">
                              <div>{{ ProductData.eProName }}</div>
                            </div>
                            <p>Model : {{ ProductData.ProModel }}</p>
                            <p>Category : {{ SelectCat.eCatName }}</p>
                            <p>Exhibitor : {{ eComName }}</p>
                            <p>Booth No : {{ BoothNo }}</p>
                            <hr />
                            <div class="my-3">
                              <p class="category-text-style my-3">Characteristic</p>
                              <p class="mb-5">{{ ProductData.eProDesc }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <div class="PcDevice">
                      <button type="button" class="btn btn-lg btn-secondary" @click.prevent="CloseProModal">
                        關閉
                      </button>
                    </div>
                    <div class="MbDevice">
                      <button type="button" class="btn btn-secondary" @click.prevent="CloseProModal">關閉</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="NoInquiry" v-if="!show">
            <table class="table table-bordered">
              <thead class="bg-light text-center">
                <tr>
                  <th scope="col">
                    <p class="text-center">
                      您未收到詢問紀錄
                      <br />
                      Currently no inquiries.
                    </p>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: '詢問記錄 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        checked: true,
        value: true,
        RegNo: '',
        inquiry: [],
        PageSize: 1,
        inquiryID: '',
        inquiryList: [],
        replyinquiryData: [],
        totalPage: '',
        totalNo: 0,
        currentPage: 1,
        ReplyMessage: '',
        show: false,
        inquiryRawData: [], //rawData
        totaltenPageNum: '', //共幾筆十頁
        tenPageNum: '',
        showpage: [],

        analyticData: false,
        replyStatus: 'all',
        hasReply: '',
        ModalData: [],
        CompanyName: '',
        eComName: '',
        BoothNo: '',
        ProductData: [],
        SelectCat: '',
        ProductCategory: [],
        lang: 'tw',
        newsUpdateTime: '',

        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },

    methods: {
      SwitchReStatus(status) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=1&replyStatus=${status}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=1&replyStatus=${status}`
        }
      },

      getPage(page) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${page}&replyStatus=${vm.replyStatus}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${page}&replyStatus=${vm.replyStatus}`
        }
      },

      nextPage() {
        const vm = this
        let nextP = Number(vm.currentPage) + 1
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${nextP}&replyStatus=${vm.replyStatus}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${nextP}&replyStatus=${vm.replyStatus}`
        }
      },

      lastPage() {
        const vm = this
        let lastP = Number(vm.currentPage) - 1

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${lastP}&replyStatus=${vm.replyStatus}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${lastP}&replyStatus=${vm.replyStatus}`
        }
      },

      nexttenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum + 1
        vm.showpage = vm.inquiryRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${vm.currentPage}&replyStatus=${vm.replyStatus}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${vm.currentPage}&replyStatus=${vm.replyStatus}`
        }
      },

      returntenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum - 1
        vm.showpage = vm.inquiryRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${vm.currentPage}&replyStatus=${vm.replyStatus}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${vm.currentPage}&replyStatus=${vm.replyStatus}`
        }
      },

      editorBtn(id) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiryEditor?no=${vm.RegNo}&id=${id}`
        } else if (vm.lang == 'en') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiryEditor?no=${vm.RegNo}&id=${id}`
        }
      },

      backInquiryPage() {
        const vm = this

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`
        } else if (vm.lang == 'en') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}`
        }
      },

      //新增回覆內容
      addResponse() {
        const vm = this

        let url = `/apiExhibitors/Inquiry/${vm.RegNo}/${vm.inquiryID}`
        let info = {
          ReplyMessage: vm.replyinquiryData.ReplyMessage,
          Archived: vm.replyinquiryData.Archived,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.replyinquiryData.ReplyMessage) {
          alert('您尚未回覆訊息！')
          return false
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)

            if (response.data.Code == 200) {
              alert('成功送出回覆訊息！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`
            } else if (response.data.Code == 251) {
              alert('系統忙碌，請稍後再試！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`
            }
          })
        }
      },

      addEnResponse() {
        const vm = this

        let url = `/apiExhibitors/Inquiry/${vm.RegNo}/${vm.inquiryID}`
        let info = {
          ReplyMessage: vm.replyinquiryData.ReplyMessage,
          Archived: vm.replyinquiryData.Archived,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.replyinquiryData.ReplyMessage) {
          alert('You have not replied to the message')
          return false
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)

            if (response.data.Code == 200) {
              alert('Successfully reply to message.')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}`
            } else if (response.data.Code == 251) {
              alert('System is busy, please try again later.')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}`
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 500) {
              alert('System is busy, please try again later.')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}`
            }
          })
        }
      },

      //新聞稿來源

      showNewsModal(id) {
        const vm = this
        let url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${id}`
        axios.get(url).then(function (response) {
          // console.log(response)
          vm.ModalData = response.data.Data

          if (vm.ModalData !== null) {
            vm.newsUpdateTime = response.data.Data.UpdateTime.split(' ')[0]
            $('#openNewsModal a[href="#nav-cn-news"]').tab('show')
            $('#openNewsModal').modal('show')
          } else {
            alert('此篇新聞稿來源已不存在！')
          }
        })
      },

      showProModal(id) {
        const vm = this

        let url = `/apiExhibitors/Product/${vm.RegNo}/${id}`
        axios.get(url).then(function (response) {
          // console.log(response.data.Data)
          vm.ProductData = response.data.Data

          if (vm.ProductData !== null) {
            //核對產品類別，取得已選的類別
            vm.SelectCat = vm.ProductCategory.find((item) => {
              return item.CatNo == vm.ProductData.CatNo
            })
            $('#openProModal a[href="#nav-cn-pro"]').tab('show')
            $('#openProModal').modal('show')
          } else {
            alert('此筆產品來源已不存在！')
          }
        })
      },

      showEnNewsModal(id) {
        const vm = this
        let url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${id}`
        axios.get(url).then(function (response) {
          // console.log(response.data.Data)
          vm.ModalData = response.data.Data

          if (response.data.Data == null) {
            alert('The source of this news no longer exists.')
          } else {
            vm.newsUpdateTime = response.data.Data.UpdateTime.split(' ')[0]
            $('#openNewsModal a[href="#nav-en-news"]').tab('show')
            $('#openNewsModal').modal('show')
          }
        })
      },

      showEnProModal(id) {
        const vm = this

        let url = `/apiExhibitors/Product/${vm.RegNo}/${id}`
        axios.get(url).then(function (response) {
          // console.log(response.data.Data)
          vm.ProductData = response.data.Data

          if (vm.ProductData !== null) {
            //核對產品類別，取得已選的類別
            vm.SelectCat = vm.ProductCategory.find((item) => {
              return item.CatNo == vm.ProductData.CatNo
            })

            $('#openProModal a[href="#nav-en-pro"]').tab('show')
            $('#openProModal').modal('show')
          } else {
            alert('The source of this product no longer exists')
          }
        })
      },

      CloseNewsModal() {
        const vm = this
        $('#openNewsModal').on('hide.bs.modal', function () {
          vm.ModalData = []
        })
        $('#openNewsModal').modal('hide')
      },

      CloseProModal() {
        const vm = this
        $('#openProModal').on('hide.bs.modal', function () {
          vm.ProductData = []
        })
        $('#openProModal').modal('hide')
      },
    },

    created() {
      const vm = this

      //語系會自動抓html lang tag

      $(() => {
        $('#SliderTop').click(() => {
          $('html,body').animate({ scrollTop: 0 }, 'slow')
          return false
        })

        $(window)
          .scroll(function () {
            if ($(this).scrollTop() > 300) {
              $('#SliderTop').fadeIn(222)
            } else {
              $('#SliderTop').stop().fadeOut(222)
            }
          })
          .scroll()
      })

      //url取展碼
      let nowPage = location.href
      vm.RegNo = nowPage.split('no=')[1].split('&')[0]

      vm.inquiryID = nowPage.split('id=')[1] //取得單頁碼

      //判定有沒有page後面的replyStatus值
      vm.hasReply = nowPage.split('replyStatus=')[1]

      if (vm.hasReply) {
        vm.currentPage = nowPage.split('page=')[1].split('&')[0] //取得頁數
        vm.replyStatus = nowPage.split('replyStatus=')[1] //取得回覆狀態
        if (vm.replyStatus == 'null') {
          vm.replyStatus = 'all'
        }
      } else {
        vm.currentPage = nowPage.split('page=')[1]
      }

      //url取載入頁面名稱

      if (vm.lang == 'tw') {
        var getHtmlurl = nowPage.split('/')[4]
        var HtmlName = getHtmlurl.split('?')[0]
      } else {
        //url取英文載入頁面參數
        var getEnHtmlurl = nowPage.split('/')[5]
        var HtmlEnName = getEnHtmlurl.split('?')[0]
      }

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //如果SS沒有資料，就將PAGE=1的訊息存入
      if (!vm.currentPage) {
        vm.currentPage = 1
      }

      //新聞稿額度
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        // console.log(response)

        vm.CompanyName = response.data.Data.Company
        vm.BoothNo = response.data.Data.BoothNo
        vm.eComName = response.data.Data.Directory_eComName
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      //取得產品類別列表
      let url2 = `/apiExhibitors/ProductCategory/${vm.RegNo}`
      axios.get(url2).then(function (response) {
        // console.log(response)
        vm.ProductCategory = response.data.Data
      })

      if (HtmlName == 'inquiry' || HtmlEnName == 'inquiry') {
        let url = `/apiExhibitors/Inquiry/${vm.RegNo}?Page=${vm.currentPage}&Reply=${vm.replyStatus}`

        axios.get(url).then(function (response) {
          // console.log(response.data.Data)

          if (response.data.pagetotal > 0) {
            vm.inquiryList = response.data.Data
            vm.totalPage = response.data.pagetotal
            vm.totalNo = response.data.datatotal

            for (let i = 0; i < vm.totalPage; i++) {
              if (i % 10 === 0) {
                vm.inquiryRawData.push([])
              }

              const page = parseInt(i / 10) //parseInt整數公式
              vm.inquiryRawData[page].push(i + 1)
            }

            //totaltenPageNum 取得共有幾筆十頁
            vm.totaltenPageNum = vm.inquiryRawData.length

            //從取得的筆數後，tenNum 計算出現第幾個十頁數

            let anaNowPage = vm.currentPage - 1 //判定第幾頁(十頁)，頁數減一避免進位

            vm.tenPageNum = parseInt(anaNowPage / 10)
            vm.showpage = vm.inquiryRawData[vm.tenPageNum]

            // vm.getlastpagenum()

            vm.show = true
          } else {
            if (vm.replyStatus == 1) {
              vm.show = true
            } else {
              vm.show = false
            }
          }
        })
      } else if (HtmlName == 'inquiryEditor' || HtmlEnName == 'inquiryEditor') {
        let url2 = `/apiExhibitors/Inquiry/${vm.RegNo}/${vm.inquiryID}`
        axios
          .get(url2)
          .then(function (response) {
            // console.log(response)

            if (response.data.Data) {
              vm.replyinquiryData = response.data.Data
            } else {
              alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`
            }
          })
          .catch((err) => {
            alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`
          })
      }
    },
  }
</script>

<style lang="scss">
  .nav-link.active {
    color: #007bff !important;
    background-color: #ffffff !important;
  }

  .list-group-item {
    padding: 0.4rem 1rem;
  }

  .card-body {
    padding: 0.7rem;
  }

  .textOverflow {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .table thead th {
    border-bottom: 0px solid #dee2e6;
    padding: 15px;
  }

  .nav-tabs {
    border-bottom: 1px solid #eef2f7;
  }
</style>
